import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Lock } from "lucide-react";
import { api } from "@/lib/api";

let cache = null;
export function usePaymentsEnabled() {
  const [enabled, setEnabled] = useState(cache);
  useEffect(() => {
    if (cache !== null) return;
    api.get("/config/pricing").then(({ data }) => { cache = !!data.payments_enabled; setEnabled(cache); }).catch(() => { cache = false; setEnabled(false); });
  }, []);
  return enabled;
}

export function ComingSoon({ title, blurb, children }) {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-lg py-10 text-center" data-testid="coming-soon">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-slate-900 text-white"><Lock className="h-7 w-7" /></div>
      <div className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-3 py-1 text-xs font-bold uppercase tracking-widest text-amber-800"><Sparkles className="h-3.5 w-3.5" /> Coming soon</div>
      <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight">{title}</h1>
      <p className="mt-2 text-muted-foreground">{blurb}</p>
      <p className="mt-1 text-xs text-muted-foreground">We're polishing this one. Your core Career OS stays free — try a mission or the AI Upskill Lab.</p>
      <div className="mt-6 flex justify-center gap-2">
        <button onClick={() => navigate("/app/upskill")} data-testid="coming-soon-upskill" className="rounded-full bg-indigo-600 px-5 py-2.5 text-sm font-bold text-white hover:bg-indigo-700">Open AI Upskill Lab</button>
        <button onClick={() => navigate("/app/missions")} data-testid="coming-soon-missions" className="rounded-full border border-border px-5 py-2.5 text-sm font-bold hover:bg-secondary">Today's mission</button>
      </div>
    </div>
  );
}
